import { createFileRoute } from '@tanstack/react-router'
import './legal.css'

export const Route = createFileRoute('/terms-of-service')({
  component: TermsOfService,
})

function TermsOfService() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Terms and Conditions</h1>
        
        <p className="legal-intro">
          Welcome to Modulus Seventeen (OPC) Private Limited. These Terms and Conditions govern your use of our applications including 'Modulus Buy,' 'Modulus Sell,' and associated products, websites, and services. By accessing or using our Platform, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our services.
        </p>

        <section className="legal-section">
          <h2>Acceptance of Terms</h2>
          <p>
            By creating an account, accessing, or using any part of our Platform, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions, along with our Privacy Policy. These terms constitute a legally binding agreement between you and Modulus Seventeen (OPC) Private Limited.
          </p>
        </section>

        <section className="legal-section">
          <h2>User Registration and Account</h2>
          <p>
            To access certain features of the Platform, you must register and create an account. You agree to provide accurate, current, and complete information during registration and to update such information to keep it accurate, current, and complete. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must immediately notify us of any unauthorized use of your account.
          </p>
        </section>

        <section className="legal-section">
          <h2>Use of Services</h2>
          <p>
            Our Platform provides a marketplace connecting buyers and sellers for various products and services. You agree to use the Platform only for lawful purposes and in accordance with these Terms. You shall not use the Platform in any way that violates any applicable local, state, national, or international law or regulation, or to engage in any fraudulent, abusive, or otherwise illegal activity.
          </p>
        </section>

        <section className="legal-section">
          <h2>Transactions and Payments</h2>
          <p>
            All transactions conducted through the Platform are between buyers and sellers. Modulus Seventeen facilitates these transactions but is not a party to them. Payment processing is handled through secure third-party payment gateways. You agree to pay all charges incurred in connection with your use of the Platform, including any applicable taxes. All sales are final, and we maintain a strict no refund policy as detailed in our Privacy Policy.
          </p>
        </section>

        <section className="legal-section">
          <h2>Seller Obligations</h2>
          <p>
            If you are a seller on the Platform, you represent and warrant that you have the right to sell the products or services you list. You agree to provide accurate descriptions, pricing, and availability information. You are responsible for fulfilling orders, providing quality products/services, and handling customer service for your sales. You must comply with all applicable laws and regulations related to your business operations.
          </p>
        </section>

        <section className="legal-section">
          <h2>Buyer Obligations</h2>
          <p>
            If you are a buyer on the Platform, you agree to review product/service descriptions carefully before making purchases. You are responsible for providing accurate delivery information and for any payment obligations. You agree to use purchased products or services in accordance with applicable laws and not for any illegal purposes.
          </p>
        </section>

        <section className="legal-section">
          <h2>Intellectual Property Rights</h2>
          <p>
            The Platform and its entire contents, features, and functionality (including but not limited to all information, software, text, displays, images, video, and audio, and the design, selection, and arrangement thereof) are owned by Modulus Seventeen (OPC) Private Limited, its licensors, or other providers of such material and are protected by copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
          </p>
        </section>

        <section className="legal-section">
          <h2>User Content</h2>
          <p>
            You retain ownership of any content you submit, post, or display on the Platform. By submitting content, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, translate, and distribute such content in connection with operating and providing the Platform. You represent and warrant that you own or have the necessary rights to submit such content and that it does not violate any third-party rights or applicable laws.
          </p>
        </section>

        <section className="legal-section">
          <h2>Prohibited Activities</h2>
          <p>You agree not to engage in any of the following prohibited activities:</p>
          <ul>
            <li>Copying, distributing, or modifying any part of the Platform without our prior written consent</li>
            <li>Using any automated system to access the Platform in a manner that sends more request messages than a human can reasonably produce</li>
            <li>Attempting to interfere with, compromise the system integrity or security, or decipher any transmissions to or from the servers running the Platform</li>
            <li>Uploading invalid data, viruses, or other malicious code through the Platform</li>
            <li>Collecting or harvesting any personally identifiable information from the Platform</li>
            <li>Impersonating another person or entity or misrepresenting your affiliation with a person or entity</li>
            <li>Engaging in any fraudulent or misleading practices</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Termination</h2>
          <p>
            We reserve the right to suspend or terminate your account and access to the Platform at our sole discretion, without notice or liability, for any reason, including but not limited to breach of these Terms and Conditions. Upon termination, your right to use the Platform will immediately cease. All provisions of these Terms which by their nature should survive termination shall survive, including ownership provisions, warranty disclaimers, and limitations of liability.
          </p>
        </section>

        <section className="legal-section">
          <h2>Disclaimer of Warranties</h2>
          <p>
            The Platform is provided on an "AS IS" and "AS AVAILABLE" basis without any warranties of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement. We do not warrant that the Platform will be uninterrupted, secure, or error-free, or that any defects will be corrected. We do not guarantee the accuracy, reliability, or completeness of any content on the Platform.
          </p>
        </section>

        <section className="legal-section">
          <h2>Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by applicable law, in no event shall Modulus Seventeen (OPC) Private Limited, its directors, employees, partners, agents, suppliers, or affiliates be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Platform.
          </p>
        </section>

        <section className="legal-section">
          <h2>Indemnification</h2>
          <p>
            You agree to defend, indemnify, and hold harmless Modulus Seventeen (OPC) Private Limited and its licensees, licensors, employees, contractors, agents, officers, and directors from and against any and all claims, damages, obligations, losses, liabilities, costs, or debt, and expenses arising from your use of the Platform, your violation of these Terms, or your violation of any third-party rights.
          </p>
        </section>

        <section className="legal-section">
          <h2>Dispute Resolution</h2>
          <p>
            Any disputes arising out of or relating to these Terms or the Platform shall be resolved through good faith negotiations between the parties. If the dispute cannot be resolved through negotiations, it shall be subject to the exclusive jurisdiction of the courts located in the jurisdiction where Modulus Seventeen (OPC) Private Limited is registered.
          </p>
        </section>

        <section className="legal-section">
          <h2>Governing Law</h2>
          <p>
            These Terms and Conditions shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions. Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights.
          </p>
        </section>

        <section className="legal-section">
          <h2>Changes to Terms</h2>
          <p>
            We reserve the right to modify or replace these Terms and Conditions at any time at our sole discretion. We will provide notice of any material changes by posting the new Terms on the Platform and updating the "Last Updated" date. Your continued use of the Platform after any such changes constitutes your acceptance of the new Terms. It is your responsibility to review these Terms periodically.
          </p>
        </section>

        <section className="legal-section">
          <h2>Severability</h2>
          <p>
            If any provision of these Terms is held to be invalid or unenforceable by a court of competent jurisdiction, the remaining provisions will continue in full force and effect. The invalid or unenforceable provision will be deemed superseded by a valid, enforceable provision that most closely matches the intent of the original provision.
          </p>
        </section>

        <section className="legal-section">
          <h2>Entire Agreement</h2>
          <p>
            These Terms and Conditions, together with our Privacy Policy and any other legal notices published by us on the Platform, constitute the entire agreement between you and Modulus Seventeen (OPC) Private Limited regarding your use of the Platform and supersede all prior agreements and understandings.
          </p>
        </section>

        <section className="legal-section">
          <h2>Contact Information</h2>
          <p>If you have any questions about these Terms and Conditions, please contact us at:</p>
          <p>
            Website: <a href="https://www.modulusseventeen.com/">https://www.modulusseventeen.com/</a><br />
            Email: <a href="mailto:sarfarazahmedkl@modulusseventeen.com">sarfarazahmedkl@modulusseventeen.com</a>
          </p>
          <p className="legal-updated">Last Updated: November 1, 2025</p>
        </section>
      </div>
    </div>
  )
}
